import React, { useEffect, useMemo, useState } from "react";
import { Select } from "antd";
import _ from "underscore";
import style from "./index.module.scss";
import TreeView, { TreeNodeType } from "./Components/TreeView";
import {
    allChildren,
    flattenTreeData,
    isCourse,
    TreeNode,
    unZipSelected,
    zipSelected
} from "service/notice";
import useClickOutside from "utils/useClickOutside";

interface UserPickerProps {
    treeData: TreeNode[];
    onChange: (users: string[]) => void;
    renderNode?: (node: TreeNodeType) => React.ReactNode;
}

export default function UserPicker({
    treeData,
    onChange,
    renderNode
}: UserPickerProps) {
    const [open, setOpen] = useState(false);
    const [selected, setSelected] = useState<string[]>([]);
    const ref = useClickOutside<HTMLDivElement>(() => setOpen(false));

    useEffect(() => {
        onChange(selected);
    }, [selected]);

    // 树形变成一维结构, 方便select显示
    const flattenedTreeData = useMemo(
        () => flattenTreeData(treeData),
        [treeData]
    );

    // 合并同一班级的学生
    const readableSelected = useMemo(
        () => zipSelected(treeData, selected),
        [treeData, selected]
    );

    function onConfirmSelect(keys: string[]) {
        setSelected(keys);
        setOpen(false);
    }

    // 相应输入框变更
    function changeHandler(value: string[], args: any) {
        // 弹出状态不允许在输入框修改
        // if (open) return;

        const currentTag = args[0]?.props.value;
        const removedStudents: string[] = [];

        if (isCourse(treeData, currentTag)) {
            const children = allChildren(treeData, currentTag);
            removedStudents.push.apply(removedStudents, children);
        }

        setSelected(
            _.difference(unZipSelected(treeData, value), removedStudents)
        );
    }

    function dropdownRender(menu?: React.ReactNode) {
        if (!open) return <div />;

        return (
            <TreeView
                initValue={selected}
                treeData={treeData}
                onSubmit={onConfirmSelect}
                onCancel={() => setOpen(false)}
                renderNode={renderNode}
            />
        );
    }

    return (
        <div className={style.root}>
            <div ref={ref}>
                <Select
                    mode="multiple"
                    value={readableSelected}
                    dropdownRender={dropdownRender}
                    style={{ width: "100%" }}
                    getPopupContainer={() => ref.current!}
                    open={open}
                    allowClear
                    onChange={changeHandler}
                    onDropdownVisibleChange={() => setOpen(true)}
                    placeholder="请选择通知范围">
                    {flattenedTreeData.map(item => (
                        <Select.Option
                            value={item.value}
                            key={item.value}
                            title={item.title}>
                            {item.label}
                        </Select.Option>
                    ))}
                </Select>
            </div>
        </div>
    );
}
